import { ProductByVendorItemUi } from '@/components/ProductsByVendor/ProductsByVendorDirectory/Table/ProductsByVendorUi';
import { ProductBySellerResponse } from '@/data/api/model/productsBySeller/productsBySellerDto';
import { formatDollarAmount } from '@/utils/amounts';
import {
  BadgeType,
  getGenericBadge,
  StatusBadgeUi,
} from '@/utils/statusBadges';

export const productBySellerResponseToProductByVendorItemUi = (
  item: ProductBySellerResponse
): ProductByVendorItemUi => {
  return {
    masterId: item.master_product_id,
    vendorId: item.product_id,
    vendorName: item.seller_name,
    productName: item.product_name,
    packagingType: item.description_presentation,
    lastUpdate: item.last_updated_at,
    price: formatDollarAmount(item.price),
    status: productBySellerStatusToStatusBadgeUi(item.status),
  };
};

export const productBySellerStatusToStatusBadgeUi = (
  status: string
): StatusBadgeUi | undefined => {
  switch (status) {
    case 'unpublished':
      return getGenericBadge(BadgeType.Warning, status, 'Inactivo');
    case 'published':
      return getGenericBadge(BadgeType.Positive, status, 'Publicado');
    default:
      return undefined;
  }
};
